import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../RootState";

// each permisson type
type permission = {
  id: number | undefined;
  name: string | undefined;
  display_name: string | undefined;
  description: string | undefined;
  created_at: string | undefined;
  update_at: string | undefined;
};

// each role type
type role = {
  id: number | undefined;
  name: string | undefined;
  display_name: string | undefined;
  description: string | undefined;
  created_at: string | undefined;
  update_at: string | undefined;
  permission: permission[];
};

// each options type
type OptsType = {
  sms: boolean;
  telegram: boolean;
  email: boolean;
};

// information of admin interface
export interface AuthState {
  id: number | undefined;
  name: string | undefined;
  family: string | undefined;
  phone: string | undefined;
  email: string | undefined;
  avatar_color: string | undefined;
  opts: OptsType | undefined;
  telegram_id: string | undefined;
  roles: role[] | [];
}

const initialState: AuthState = {
  id: undefined,
  name: undefined,
  family: undefined,
  phone: undefined,
  email: undefined,
  avatar_color: undefined,
  opts: undefined,
  telegram_id: undefined,
  roles: [],
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAdminInfo: (state, action: PayloadAction<AuthState>) => {
      Object.assign(state, action.payload);
    },
  },
});

export const adminInfoSelector = (state: RootState) => state.auth;

export const { setAdminInfo } = authSlice.actions;

export default authSlice.reducer;
